/**
 * Utilidades para emparejar assets de línea con el contexto del terminal HMI.
 */

/**
 * @param {Array<object>} lines
 * @param {{ prodLine?: string, prodLineId?: number, factory?: string }} terminal
 * @returns {object|null}
 */
export function findLineForTerminal(lines, terminal) {
  if (!terminal?.bound || !Array.isArray(lines) || lines.length === 0) {
    return null
  }

  const targetLine = String(terminal.prodLine || '').trim().toLowerCase()
  const targetFactory = String(terminal.factory || '').trim().toUpperCase()
  const targetId = terminal.prodLineId ? String(terminal.prodLineId) : ''

  const candidates = lines.filter((line) => {
    if (!targetFactory) return true
    const lineFactory = String(
      line.factory ||
      line.hierarchical_level?.[0] ||
      line.HierarchicalLevel?.[0] ||
      ''
    ).toUpperCase()
    return !lineFactory || lineFactory === targetFactory
  })

  if (targetId) {
    const byId = candidates.find((line) => {
      const id = line.id ?? line.ID
      return id != null && String(id) === targetId
    })
    if (byId) return byId
  }

  if (!targetLine) return null

  const exact = candidates.find((line) => {
    const codes = [
      line.code,
      line.Code,
      line.line,
      line.sap_code,
      line.sapCode,
    ]
      .filter(Boolean)
      .map((value) => String(value).trim().toLowerCase())
    return codes.some((code) => code === targetLine)
  })
  if (exact) return exact

  return (
    candidates.find((line) => {
      const code = String(line.code || line.line || '').trim().toLowerCase()
      return code.includes(targetLine) || targetLine.includes(code)
    }) ?? null
  )
}

/**
 * Construye un objeto de línea mínimo cuando aún no hay assets cargados.
 * @param {{ factory?: string, prodLine?: string, sapCode?: string, prodLineId?: number, name?: string }} terminal
 */
export function buildLineFromTerminal(terminal) {
  if (!terminal?.bound) return null

  return {
    factory: terminal.factory,
    line: terminal.prodLine,
    code: terminal.prodLine,
    sap_code: terminal.sapCode || terminal.prodLine,
    id: terminal.prodLineId || undefined,
    name: terminal.name || terminal.prodLine,
    _fromTerminal: true,
  }
}
